/*
 * 各ページの権限設定
 *
 * 各プロパティの説明
 * accessPermission: ページへのアクセス権
 *
 *
 */
export default {
  data () {
    return {
      entity: {}
    }
  },
  methods: {
    permission: function () {
      return {
        logout: {
          entry: {
            accessPermission: [
              true,
              true,
              true
            ]
          }
        },
        'js/encoding.min.js.map': {
          update: {
            accessPermission: [
              false,
              true,
              true
            ]
          }
        },
        'js/jszip.js': {
          update: {
            accessPermission: [
              false,
              true,
              true
            ]
          }
        },
        'js/FileSaver.js': {
          update: {
            accessPermission: [
              false,
              true,
              true
            ]
          }
        },
        stockDataSet: {
          entry: {
            accessPermission: [
              false,
              true,
              true
            ],
            sectionCodeNumber: [
              '',
              '',
              'readonly'
            ],
            individualCodeNumber: [
              '',
              '',
              'readonly'
            ],
            goodsCodeNumber: [
              '',
              '',
              'readonly'
            ],
            goodsNameNumber: [
              '',
              '',
              'readonly'
            ],
            quantityNumber: [
              '',
              '',
              'readonly'
            ],
            janCodeNumber: [
              '',
              '',
              'readonly'
            ],
            generalItem1Number: [
              '',
              '',
              'readonly'
            ],
            headerExist: [
              '',
              '',
              'readonly'
            ],
            saveBtn: [
              '',
              '',
              'displayNone'
            ]
          }
        },
        goodsInfoEdit: {
          update: {
            accessPermission: [
              false,
              true,
              false
            ]
          }
        },
        goodsInfoList: {
          entry: {
            accessPermission: [
              false,
              true,
              false
            ]
          }
        },
        goodsInfoUpload: {
          entry: {
            accessPermission: [
              false,
              true,
              false
            ]
          }
        },
        goodsInfoUpload2: {
          entry: {
            accessPermission: [
              false,
              true,
              false
            ]
          }
        },
        readerSet: {
          entry: {
            accessPermission: [
              false,
              true,
              true
            ]
          }
        },
        inventoryTargetFileList: {
          entry: {
            accessPermission: [
              true,
              true,
              true
            ],
            enterpriseCode: [
              '',
              'displayNone',
              ''
            ]
          }
        },
        stockFileUpload: {
          entry: {
            accessPermission: [
              false,
              true,
              true
            ],
            inventoryIdentyName: [
              '',
              '',
              ''
            ]
          }
        },
        stockFileUpload2: {
          entry: {
            accessPermission: [
              false,
              true,
              true
            ],
            inventoryIdentyName: [
              '',
              '',
              ''
            ]
          }
        },
        userList: {
          entry: {
            accessPermission: [
              true,
              true,
              false
            ],
            enterpriseCode: [
              '',
              'displayNone',
              ''
            ]
          }
        },
        csvChecker2: {
          entry: {
            accessPermission: [
              false,
              true,
              true
            ]
          }
        },
        csvChecker: {
          entry: {
            accessPermission: [
              false,
              true,
              true
            ]
          }
        },
        userEdit: {
          entry: {
            accessPermission: [
              true,
              true,
              false
            ],
            bunshou: [
              '',
              '',
              'dummy'
            ],
            enterpriseCode: [
              '',
              'readonly',
              ''
            ],
            enterpriseName: [
              'readonly',
              'readonly',
              ''
            ],
            sectionCode: [
              '',
              '',
              ''
            ],
            sectionName: [
              'displayNone',
              'readonly',
              ''
            ],
            userId: [
              '',
              '',
              ''
            ],
            userName: [
              '',
              '',
              ''
            ],
            userPassword: [
              '',
              '',
              ''
            ],
            userDiv: [
              '',
              '',
              ''
            ],
            inventoryDownloadDiv: [
              'displayNone',
              '',
              ''
            ],
            stockFileOperationDiv: [
              'displayNone',
              'displayNone',
              'displayNone'
            ],
            inventoryCompletionDiv: [
              'displayNone',
              '',
              ''
            ],
            readerSettingDiv: [
              'displayNone',
              '',
              ''
            ],
            simpleUserCode: [
              'displayNone',
              '',
              ''
            ],
            simplePassword: [
              'displayNone',
              '',
              ''
            ],
            save: [
              '',
              '',
              ''
            ],
            cancel: [
              '',
              '',
              'displayNone'
            ],
            delete: [
              'displayNone',
              'displayNone',
              ''
            ]
          },
          update: {
            accessPermission: [
              true,
              true,
              true
            ],
            bunshou: [
              '',
              '',
              ''
            ],
            enterpriseCode: [
              'readonly',
              'readonly',
              'readonly'
            ],
            enterpriseName: [
              'readonly',
              'readonly',
              'readonly'
            ],
            sectionCode: [
              'displayNone',
              '',
              'readonly'
            ],
            sectionName: [
              'readonly',
              'readonly',
              'readonly'
            ],
            userId: [
              'readonly',
              'readonly',
              'readonly'
            ],
            userName: [
              '',
              '',
              ''
            ],
            userPassword: [
              '',
              '',
              ''
            ],
            userDiv: [
              'readonly',
              '',
              'readonly'
            ],
            inventoryDownloadDiv: [
              'readonly',
              '',
              'readonly'
            ],
            stockFileOperationDiv: [
              'displayNone',
              'displayNone',
              'displayNone'
            ],
            inventoryCompletionDiv: [
              'readonly',
              '',
              'readonly'
            ],
            readerSettingDiv: [
              'readonly',
              '',
              'readonly'
            ],
            simpleUserCode: [
              'displayNone',
              '',
              ''
            ],
            simplePassword: [
              'displayNone',
              '',
              ''
            ],
            save: [
              '',
              '',
              ''
            ],
            cancel: [
              '',
              '',
              'displayNone'
            ],
            delete: [
              '',
              '',
              'displayNone'
            ]
          }
        },
        accountbookList: {
          entry: {
            accessPermission: [
              true,
              true,
              true
            ]
          }
        },
        inventoryInfoList: {
          entry: {
            accessPermission: [
              false,
              true,
              true
            ],
            delete: [
              false,
              true,
              false
            ],
            release: [
              false,
              true,
              false
            ],
            approval: [
              false,
              true,
              false
            ]
          },
          update: {
            accessPermission: [
              false,
              true,
              true
            ]
          }
        },
        sectionEdit: {
          entry: {
            accessPermission: [
              true,
              false,
              false
            ],
            bunshou: [
              '',
              '',
              'dummy'
            ],
            enterpriseCode: [
              '',
              '',
              ''
            ],
            enterpriseName: [
              'readonly',
              '',
              ''
            ],
            sectionCode: [
              '',
              '',
              ''
            ],
            sectionName: [
              '',
              '',
              ''
            ],
            dsShopCode: [
              'dummy',
              '',
              'displayNone'
            ],
            dsShopName: [
              'readonly',
              'readonly',
              'displayNone'
            ],
            save: [
              '',
              '',
              ''
            ],
            cancel: [
              '',
              '',
              ''
            ],
            delete: [
              'displayNone',
              '',
              ''
            ],
            editBtn: [
              'displayNone',
              'displayNone',
              'displayNone'
            ],
            editedsectionCode: [
              'displayNone',
              'displayNone',
              'displayNone'
            ]
          },
          update: {
            accessPermission: [
              true,
              true,
              true
            ],
            bunshou: [
              '',
              '',
              'dummy'
            ],
            enterpriseCode: [
              'readonly',
              'readonly',
              'readonly'
            ],
            enterpriseName: [
              'readonly',
              'readonly',
              'readonly'
            ],
            sectionCode: [
              'readonly',
              'readonly',
              'readonly'
            ],
            sectionName: [
              '',
              '',
              'readonly'
            ],
            dsShopCode: [
              'dummy',
              'dummy',
              'displayNone'
            ],
            dsShopName: [
              'readonly',
              'readonly',
              'displayNone'
            ],
            save: [
              '',
              '',
              'displayNone'
            ],
            cancel: [
              '',
              '',
              'displayNone'
            ],
            delete: [
              '',
              'displayNone',
              'displayNone'
            ],
            editBtn: [
              '',
              '',
              'displayNone'
            ],
            editedsectionCode: [
              'displayNone',
              'displayNone',
              'displayNone'
            ]
          }
        },
        sectionList: {
          entry: {
            accessPermission: [
              true,
              true,
              false
            ],
            enterpriseCode: [
              '',
              'readonly',
              ''
            ],
            newCreate: [
              '',
              'displayNone',
              ''
            ],
            csvOutput: [
              '',
              'displayNone',
              'displayNone'
            ]
          },
          update: {
            accessPermission: [
              true,
              true,
              false
            ]
          }
        },
        enterpriseList: {
          entry: {
            accessPermission: [
              true,
              false,
              false
            ]
          },
          update: {
            accessPermission: [
              true,
              false,
              false
            ]
          }
        },
        enterpriseEdit: {
          entry: {
            accessPermission: [
              true,
              false,
              false
            ],
            bunshou: [
              '',
              '',
              'dummy'
            ],
            enterpriseCode: [
              '',
              '',
              ''
            ],
            enterpriseName: [
              '',
              '',
              ''
            ],
            enterpriseAuthCode: [
              '',
              '',
              ''
            ],
            enterpriseAuthPass: [
              '',
              '',
              ''
            ],
            domain: [
              '',
              '',
              ''
            ],
            licenseStartDate: [
              '',
              '',
              ''
            ],
            licenseEndDate: [
              'dummy',
              '',
              ''
            ],
            licenseType: [
              '',
              '',
              ''
            ],
            industryType: [
              'displayNone',
              '',
              ''
            ],
            businessType: [
              '',
              'displayNone',
              'displayNone'
            ],
            bomAttachDiv: [
              'displayNone',
              '',
              ''
            ],
            otherAccessToken: [
              'displayNone',
              'displayNone',
              'displayNone'
            ],
            installmentTime: [
              'displayNone',
              'dummy',
              ''
            ],
            inventoryWayDiv: [
              'displayNone',
              '',
              ''
            ],
            simpleAuthCertificationDiv: [
              'displayNone',
              '',
              ''
            ],
            inventoryDeleteDiv: [
              'displayNone',
              '',
              ''
            ],
            inventoryCancelDiv: [
              'displayNone',
              '',
              ''
            ],
            accountbookDiv: [
              'displayNone',
              '',
              ''
            ],
            save: [
              '',
              '',
              ''
            ],
            cancel: [
              '',
              'displayNone',
              'displayNone'
            ],
            delete: [
              'displayNone',
              '',
              ''
            ]
          },
          update: {
            accessPermission: [
              true,
              true,
              true
            ],
            bunshou: [
              '',
              '',
              'dummy'
            ],
            enterpriseCode: [
              'readonly',
              'readonly',
              'readonly'
            ],
            enterpriseName: [
              '',
              'readonly',
              'readonly'
            ],
            enterpriseAuthCode: [
              '',
              'readonly',
              'readonly'
            ],
            enterpriseAuthPass: [
              '',
              'readonly',
              'readonly'
            ],
            domain: [
              '',
              'readonly',
              'readonly'
            ],
            licenseStartDate: [
              '',
              'displayNone',
              'displayNone'
            ],
            licenseEndDate: [
              'dummy',
              'displayNone',
              'displayNone'
            ],
            licenseType: [
              '',
              'displayNone',
              'displayNone'
            ],
            industryType: [
              'readonly',
              '',
              'readonly'
            ],
            businessType: [
              '',
              'displayNone',
              'displayNone'
            ],
            bomAttachDiv: [
              'displayNone',
              '',
              'readonly'
            ],
            otherAccessToken: [
              'displayNone',
              '',
              'displayNone'
            ],
            installmentTime: [
              'readonly',
              '',
              'readonly'
            ],
            inventoryWayDiv: [
              'displayNone',
              '',
              'readonly'
            ],
            simpleAuthCertificationDiv: [
              'displayNone',
              '',
              'readonly'
            ],
            inventoryDeleteDiv: [
              'displayNone',
              '',
              'readonly'
            ],
            inventoryCancelDiv: [
              'displayNone',
              '',
              'readonly'
            ],
            accountbookDiv: [
              'displayNone',
              '',
              'readonly'
            ],
            save: [
              '',
              '',
              'displayNone'
            ],
            cancel: [
              '',
              'displayNone',
              'displayNone'
            ],
            delete: [
              '',
              'displayNone',
              'displayNone'
            ]
          }
        },
        dsshop: {
          entry: {
            accessPermission: [
              true,
              false,
              false
            ]
          },
          update: {
            accessPermission: [
              true,
              true,
              false
            ]
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/permission.js